import { render, staticRenderFns } from "./TableGraph.vue?vue&type=template&id=bc01cd12&scoped=true&"
import script from "./TableGraph.vue?vue&type=script&lang=js&"
export * from "./TableGraph.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc01cd12",
  null
  
)

export default component.exports